const DEFAULT_API_URL = 'https://api.aguadastats.com/api';

export const API_BASE_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(/\/+$/, '');

export const apiUrl = (path = '') => `${API_BASE_URL}/${String(path).replace(/^\/+/, '')}`;

export const imageUrl = (nombre) =>
    apiUrl(`imagenes/download/${encodeURIComponent(nombre ?? '')}.webp`);
